export enum OptionShortTypeEnum {
	CALL = 'C',
	PUT = 'P',
}
